import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';

const TribunLoginFailModal = props => {

  /*const buttonConfig = {
    primary: {
      label: 'Ana Sayfaya Dön',
      onClick: props.onPrimaryButtonClick
    }
  };*/

  const successMessage = 'Kuponun durumu ile ilgili Merkezi Bahis Sistemi\'nden bilgi alamıyoruz. En kısa sürede seni kısa mesaj ile bilgilendireceğiz. İptal onaylandığında "Kuponlarım" sayfasından görebileceksin';

  return (
    <Message type="none">
      <p dangerouslySetInnerHTML={ { __html: successMessage } } />
    </Message>
  );
};

TribunLoginFailModal.propTypes = {
  balance: PropTypes.number
};

export default TribunLoginFailModal;
